import { getHttpClient } from "./auth";

/**
 * Récupère la liste des produits incontournables avec filtres optionnels
 * @param {Object} filters - Filtres à appliquer
 * @param {Array} filters.animalTypes - Liste des IDs de types d'animaux
 * @returns {Promise} Liste des produits incontournables
 */
export const getIncontournables = async (filters = {}) => {
  try {
    let url = "/incontournables";
    const params = new URLSearchParams();
    if (filters.animalTypes && filters.animalTypes.length > 0) {
      filters.animalTypes.forEach(animalTypeId => {
        // Append with [] to match the required format
        params.append("product.animalTypes.id[]", animalTypeId);
      });
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const response = await getHttpClient().get(url);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des produits incontournables:", error);
    throw error;
  }
};

/**
 * Normalise les données des produits incontournables pour le composant ProductCardSlide
 * @param {Array} items - Liste des items du web service
 * @returns {Array} Liste des produits normalisés
 */
export const normalizeIncontournablesProducts = items => {
  if (!items || !Array.isArray(items)) {
    return [];
  }

  return items.map(item => {
    const product = item.product;
    let images = [];
    if (product.variant?.imagesDetails && product.variant.imagesDetails.length > 0) {
      images = product.variant.imagesDetails;
    } else if (product.imagesDetails) {
      images = product.imagesDetails;
    }
    return {
      id: product.id || item.id,
      name: product?.name || product.variant?.name ||  product.variant?.ref || "Produit sans nom",
      slug: product.slug || `product-${item.id}`,
      description: product.description || "",
      gamme: product.gamme_supplyvet || "",
      has_favorite: product.has_favorite || false,
      images: images || [],
      variant: {
        ...product.variant,
        currentChannelPricings: product.variant?.currentChannelPricings || {
          price: 0,
          originalPrice: null,
          lowestPriceBeforeDiscount: null,
        },
      },
      variantsDetails: product.variantsDetails || [],
      position: item.position || 0,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    };
  });
};


/**
 * Normalise les filtres des types d'animaux
 * @param {Object} filters - Objet filters de la réponse API
 * @returns {Array} Liste normalisée des types d'animaux
 */
export const normalizeAnimalTypes = filters => {
  if (!filters || !filters.animalTypes) {
    return [];
  }

  return Object.values(filters.animalTypes).map(animalType => ({
    id: animalType.id,
    name: animalType.name,
  }));
};
